import { Modal } from "@mantine/core";
import React from "react";

import ModalHeader from "components/ModalHeader";
import { Organization } from "types";
import UpdateFormProgram from "./editform";

type CreateProjectModalProps = {
  opened: boolean;
  onClose: () => void;
  programId?: string;
};

function ProgramUpdateModal({
  opened,
  onClose,
  programId,
}: CreateProjectModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      overlayOpacity={0.5}
      shadow="xs"
      withCloseButton={false}
      transitionDuration={300}
      centered
    >
      <ModalHeader
        title="Edit Program"
        onClose={onClose}
        ariaLabel="Close add program modal"
      />
      <UpdateFormProgram programId={programId} onClose={onClose} />
    </Modal>
  );
}

export default ProgramUpdateModal;
